import React from 'react'
import {
  Box,
  Button,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import { Close } from '@mui/icons-material'

const Subsection = ({ subsection, setSubsection, removeSubsection }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <TextField
          value={subsection.name}
          label={'Subsection Name'}
          onChange={(e) =>
            setSubsection({ ...subsection, name: e.target.value })
          }
          sx={{ mb: 2 }}
        ></TextField>
        <Button
          color={'warning'}
          onClick={removeSubsection}
          endIcon={<Close />}
        >
          Remove Subsection
        </Button>
      </Box>

      <TextField
        fullWidth
        value={subsection.videoLink || ''}
        label={'Video Link'}
        onChange={(e) =>
          setSubsection({ ...subsection, videoLink: e.target.value })
        }
        sx={{ mb: 2 }}
      ></TextField>
      <TextField
        fullWidth
        label={'Video Description'}
        multiline
        rows={6}
        value={subsection.videoDescription || ''}
        onChange={(e) =>
          setSubsection({ ...subsection, videoDescription: e.target.value })
        }
        sx={{ mb: 4 }}
      ></TextField>

      <TextField
        fullWidth
        value={subsection.pictureLink || ''}
        label={'Image Link'}
        onChange={(e) =>
          setSubsection({ ...subsection, pictureLink: e.target.value })
        }
        sx={{ mb: 2 }}
      ></TextField>
      <TextField
        fullWidth
        label={'Image Description'}
        multiline
        rows={6}
        value={subsection.pictureDescription || ''}
        onChange={(e) =>
          setSubsection({ ...subsection, pictureDescription: e.target.value })
        }
      ></TextField>
    </>
  )
}

export default Subsection
